const HEADER_STORAGE_NAME = 'config'

let header

export default function getHeaders () {
  if (!header) {
    header = getPartnerFromQuery() || getPartnerFromStorage() || getPartnerFromCookie() || getDefaultPartner()
    saveHeaders(header)
  }

  return header
}

function getDefaultPartner () {
  return {
    client_id: process.env.VUE_APP_CLIENT_ID
  }
}

function getPartnerFromCookie () {
  let clientId
  let partner

  clientId = getCookie('client_id')

  if (clientId) {
    const header = {
      client_id: clientId
    }

    partner = getCookie('partner')

    if (partner) header.partner = partner

    return header
  }

  return undefined
}

function getPartnerFromStorage () {
  const storageHeader = window.sessionStorage.getItem(HEADER_STORAGE_NAME)

  if (storageHeader) {
    return JSON.parse(storageHeader).headers
  }

  return undefined
}

function getPartnerFromQuery () {
  let clientId
  let partner

  clientId = getFromQuery('client_id')

  if (clientId) {
    const header = {
      client_id: clientId
    }

    saveCookie('client_id', clientId)

    partner = getFromQuery('partner')

    if (partner) {
      saveCookie('partner', partner)
      header.partner = partner
    }

    return header
  }

  return undefined
}

function getFromQuery (key) {
  const match = new RegExp(`${key}=([^&,#,/]+)`).exec(window.location.href)

  if (match) {
    return match[1]
  }

  return undefined
}

function saveHeaders (headers) {
  sessionStorage.setItem(HEADER_STORAGE_NAME, JSON.stringify({
    headers
  }))
}

function saveCookie (key, value) {
  const today = new Date()
  const expiredDate = new Date(
    today.getFullYear(),
    today.getMonth(),
    today.getDate() + 1
  )

  document.cookie = `${key}=${value};expires=${expiredDate};path=/;domain=ciclic.com.br`
}

function getCookie (key) {
  const cookie = document.cookie.split(';').find((c) => c.match(`${key}=`))
  return cookie ? new RegExp(`${key}=(.+)`).exec(cookie)[1] : false
}

export function getPartnerRegulationLink () {
  const { client_id: clientId } = getHeaders()
  if (/^key-livelo/g.test(clientId) || /^key-leadslivelo/g.test(clientId)) {
    return 'https://www.ciclic.com.br/regulamento-livelo-celular-portateis'
  }
  if (/^key-dotz/g.test(clientId)) {
    return 'https://www.ciclic.com.br/dotz/regulamento-portateis'
  }
}

export function getPartnerName () {
  const { client_id: clientId } = getHeaders()
  if (/^key-livelo/g.test(clientId) || /^key-leadslivelo/g.test(clientId) || /^key-passageirodeprimeira/g.test(clientId)) {
    return 'livelo'
  }
  if (/^key-dotz/g.test(clientId)) {
    return 'dotz'
  }
}
